// Branding shared by the retained policy pages. Original site content is archived.
export const Content = {
  name: "Dynamoid",
  logo: "logo.png",
  blurb: "Understanding reality",
};
